/* --------------------------------------------------------------------------------------
   xwBoundingBox.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { useRef, useEffect } from "preact/hooks"
import { MFDApp } from "../../constants/MFDApp.const"

const XwBoundingBox = props => {
    const elementRef = useRef(null)
    const elementId = `bbx-${new Date().getTime()}`
    useEffect(() => {
        $(elementRef.current).xrxboundingbox(getOptions(props))
        return () => $(elementRef.current).xrxboundingbox("destroy")
    }, [])
    return <div ref={elementRef} className={props.className} id={elementId}>
        {props.children}
    </div>
}

const getOptions = props => ({
    ...props,
    theme: props.theme || MFDApp.theme,
    children: undefined
})

export default XwBoundingBox